import { ElementState, Preview } from "@creatomate/preview";
import { ElementSource } from "chq";

const moveElementToTrack = async (
  targetTrack: number, preview: Preview, element?: ElementState, time?: number
): Promise<void> => {
  if (!preview.state || !element) return;
  const source = preview.getSource();

  const elementStartTime = element.localTime;
  const elementEndTime = elementStartTime + element.duration;

  // filter the elements from the target track
  const targetTrackElements = source.elements.filter(
    (element: ElementSource) => element.track === targetTrack);

  let updatedElement = { ...element, time };

  // filter the elements with a time that clashes with the current element
  const clashedTrackElements = targetTrackElements.filter((elm: ElementState) => {
    const filterStartTime = elm.globalTime;
    const filterEndTime = filterStartTime + elm.duration;

    if (filterStartTime > elementEndTime || filterEndTime < elementStartTime) {
      return false;
    }

    return true;
  });

  if (clashedTrackElements.length > 0) {
    const lastClashedElement = clashedTrackElements[clashedTrackElements.length - 1];
    updatedElement = {
      ...updatedElement,
      time: lastClashedElement.time + lastClashedElement.duration,
      duration: element.duration
    };
  }

  const updatedElements = source.elements.map((element: ElementSource) => {
    if (element.id !== updatedElement.source.id) {
      if (targetTrack < 1) {
        return {
          ...element,
          track: element.track + 1
        };
      }

      return element;
    }

    return {
      ...element,
      time: updatedElement.time,
      duration: updatedElement.duration,
      track: targetTrack < 1 ? 1 : targetTrack
    };
  });

  await preview.setSource({
    ...source,
    elements: updatedElements
  });
};

export default moveElementToTrack;
